





































import { CheckIsMUZE } from "@/helper/shareHelper";
import { MerchantId } from "@/helper/userHelper";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const IsMUZE = CheckIsMUZE();
const StoreLogIn = namespace("LogIn");

@Component
export default class DropdownUser extends Vue {
  private show = false;
  private optionList = [
    {
      lock: false,
      name: "user_Profile",
      icon: "fa fa-user",
      link: "profileSetting",
      outProject: false,
      isShow: true,
    },
    {
      lock: false,
      name: "user_Subscription",
      icon: "fa fa-credit-card",
      link: `${process.env.VUE_APP_PeakAccount}setting/billing`,
      outProject: true,
      isShow: !IsMUZE,
    },
    { lock: true, name: "user_Help", icon: "fa fa-question-circle", isShow: true },
    { lock: true, name: "user_InviteFriends", icon: "fa fa-paper-plane", isShow: true },
    { lock: false, name: "logout", icon: "fas fa-sign-out-alt", link: "logout", isShow: true },
  ];

  @StoreLogIn.Getter
  public getUserModel!: any;

  get emi() {
    return MerchantId().PeakEncryption();
  }

  public Hide() {
    this.show = false;
  }

  public SetUrl(option: any) {
    return { name: option.link, query: { emi: this.emi, logout: true } };
  }

  public RedirectToPeak(option: any) {
    window.open(`${option.link}?emi=${this.emi}`);
    this.show = false;
  }
}
